export enum IndirectDecisionType
{
    SendAutomatically = 1,
    OpenDecisionDialog = 2,
    DoNotSendDecision = 3
}